var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-license-container"},[_c('h1',{staticClass:"main-title"},[_vm._v("营业执照模板")]),_c('div',{staticClass:"img-wrapper"},[_c('img',{staticClass:"license-img",attrs:{"src":_vm.licenseImg,"alt":"营业执照模板示例"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }